// 平台支持度
const PLATFORMSUPPORT = {
    'Firefox': '1',
    'Edge': '2',
    'IE': '3',
    '360安全浏览器': '2',
    '360极速浏览器': '2',
    '360兼容模式': '2',
    'Chrome': '1',
    'Safari': '2',
    'Win2000': '3',
    'WinXP': '2',
    'Win2003': '3',
    'WindowsVista': '2',
    'Win7': '1',
    'Win8': '1',
    'Win8.1': '1',
    'Win10': '1',
    'Mac': '1',
    'Unix': '3',
    'Linux': '3',
    'Other': '2',
}

export {
    PLATFORMSUPPORT
}


//////////////////
// WEBPACK FOOTER
// /Users/wangmengyuan/Code/xbz-students-web/vendor/xbz-front-compilb/src/libs/config.js
// module id = null
// module chunks = 